import { getStaffMemberQueryOptions } from "@packages/api-client/hooks/staffController";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { StaffForm } from "@/routes/_auth/app/_app/org/$orgId/staff/-components/StaffForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/staff/$staffId/edit",
)({
	loader: async ({ context, params }) => {
		const { orgId, staffId } = params;

		// Preload staff member data
		await context.queryClient.ensureQueryData(
			getStaffMemberQueryOptions(orgId, staffId),
		);

		return { orgId, staffId };
	},
	component: EditStaffPage,
});

function EditStaffPage() {
	const { orgId, staffId } = Route.useParams();

	// Fetch staff member data
	const { data: staffMember } = useSuspenseQuery(
		getStaffMemberQueryOptions(orgId, staffId),
	);

	return (
		<div className="h-full flex flex-col space-y-6">
			<div className="h-full overflow-auto" data-testid="staff-form-container">
				<StaffForm staffMember={staffMember} />
			</div>
		</div>
	);
}
